import { render, staticRenderFns } from "./PageConfigAdmin.vue?vue&type=template&id=3c07e9f3&scoped=true"
import script from "./PageConfigAdmin.vue?vue&type=script&lang=js"
export * from "./PageConfigAdmin.vue?vue&type=script&lang=js"
import style0 from "./PageConfigAdmin.vue?vue&type=style&index=0&id=3c07e9f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c07e9f3",
  null
  
)

export default component.exports